var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewDetailsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34799_120423)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_34799_120423",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_34799_120423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.30775 20.5C4.80908 20.5 4.38308 20.3234 4.02975 19.9703C3.67658 19.6169 3.5 19.1909 3.5 18.6923V5.30775C3.5 4.80908 3.67658 4.38308 4.02975 4.02975C4.38308 3.67658 4.80908 3.5 5.30775 3.5H18.6923C19.1909 3.5 19.6169 3.67658 19.9703 4.02975C20.3234 4.38308 20.5 4.80908 20.5 5.30775V11.6328C20.2538 11.5276 20.0073 11.4385 19.7605 11.3655C19.5137 11.2923 19.2602 11.234 19 11.1905V5.30775C19 5.23075 18.9679 5.16025 18.9038 5.09625C18.8398 5.03208 18.7693 5 18.6923 5H5.30775C5.23075 5 5.16025 5.03208 5.09625 5.09625C5.03208 5.16025 5 5.23075 5 5.30775V18.6923C5 18.7693 5.03208 18.8398 5.09625 18.9038C5.16025 18.9679 5.23075 19 5.30775 19H11.1655C11.2027 19.2768 11.2578 19.5387 11.3308 19.7855C11.4039 20.0323 11.493 20.2705 11.598 20.5H5.30775ZM5 18V19V5V11.1905V11.1155V18ZM7.25 16.6345H11.2673C11.3109 16.3743 11.3757 16.1208 11.4615 15.874C11.5475 15.6272 11.6411 15.3808 11.7423 15.1348H7.25V16.6345ZM7.25 12.75H13.5905C14.0212 12.3847 14.4808 12.0786 14.9693 11.8317C15.4578 11.5849 15.9808 11.4096 16.5385 11.3058V11.25H7.25V12.75ZM7.25 8.86525H16.75V7.3655H7.25V8.86525Z",
    fill: "#4B5563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9111 27L21.0111 22.1C20.6222 22.4111 20.175 22.6574 19.6694 22.8389C19.1639 23.0204 18.6259 23.1111 18.0556 23.1111C16.6426 23.1111 15.4468 22.6218 14.4681 21.6431C13.4894 20.6644 13 19.4685 13 18.0556C13 16.6426 13.4894 15.4468 14.4681 14.4681C15.4468 13.4894 16.6426 13 18.0556 13C19.4685 13 20.6644 13.4894 21.6431 14.4681C22.6218 15.4468 23.1111 16.6426 23.1111 18.0556C23.1111 18.6259 23.0204 19.1639 22.8389 19.6694C22.6574 20.175 22.4111 20.6222 22.1 21.0111L27 25.9111L25.9111 27ZM18.0556 21.5556C19.0278 21.5556 19.8542 21.2153 20.5347 20.5347C21.2153 19.8542 21.5556 19.0278 21.5556 18.0556C21.5556 17.0833 21.2153 16.2569 20.5347 15.5764C19.8542 14.8958 19.0278 14.5556 18.0556 14.5556C17.0833 14.5556 16.2569 14.8958 15.5764 15.5764C14.8958 16.2569 14.5556 17.0833 14.5556 18.0556C14.5556 19.0278 14.8958 19.8542 15.5764 20.5347C16.2569 21.2153 17.0833 21.5556 18.0556 21.5556Z",
    fill: "#4B5563"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34799_120423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewDetailsIcon);
export default __webpack_public_path__ + "static/media/ViewDetailsIcon.15663934a527bf70cf5f923f315c97b5.svg";
export { ForwardRef as ReactComponent };